export default __webpack_public_path__ + "static/media/logo-tourism-watch.76d12b77.svg";